import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { getCountryCallingCode, parsePhoneNumber, CountryCode, getCountries, AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss']
})
export class PhoneInputComponent implements OnInit, AfterViewInit, OnChanges {
  obj_countries: { name: string, code: CountryCode, dialCode: string }[] = [];
  // vc_selectedCountryCode: CountryCode = 'PE';
  vc_formattedPhoneNumber: string = '';
  vc_phoneNumberValid: boolean = false;
  vc_phoneNumber: string = '';

  @Input() obj_selectedCountryCode: CountryCode;
  @Input() obj_initialPhoneNumber: string = '';
  @Output() obj_newPhoneNumber = new EventEmitter<string>();
  @Output() obj_newNormalizedPhoneNumber = new EventEmitter<string>();


  ngOnInit(): void {
    this.fn_populateCountries();
  }

  ngAfterViewInit(): void {
    if (this.obj_initialPhoneNumber !== '') {
        this.parsePhoneNumber(this.obj_initialPhoneNumber);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.obj_initialPhoneNumber !== '') {
        this.parsePhoneNumber(this.obj_initialPhoneNumber);
    }
  }

  parsePhoneNumber(fullPhoneNumber: string) {
    const phoneNumber = parsePhoneNumberFromString(fullPhoneNumber);

    if (!phoneNumber) {
      console.error('Invalid phone number');
      this.vc_phoneNumberValid = false;
      return;
    }

    this.obj_selectedCountryCode = phoneNumber.country;
    this.vc_phoneNumber = phoneNumber.nationalNumber;
  }

  fn_populateCountries(): void {
    const supportedCountries = getCountries();
    supportedCountries.forEach(countryCode => {
      // Use a separate service or library to get the country names
      // For simplicity, using the country code as the name here
      const dialCode = getCountryCallingCode(countryCode as CountryCode);
      this.obj_countries.push({ 
        name: countryCode, 
        code: countryCode as CountryCode, 
        dialCode 
      });
    });
  }

  fn_emitPhoneNumber(phonenumber): void{
    const phone = parsePhoneNumber(phonenumber, this.obj_selectedCountryCode)
    //let asYouType = new AsYouType(this.vc_selectedCountryCode);
    //let phone = asYouType.input(phonenumber);
    this.obj_newPhoneNumber.emit(phone.number);
    this.obj_newNormalizedPhoneNumber.emit(phonenumber);
  }

  fn_onCountryChange(): void {
    this.fn_validatePhoneNumber();
  }

  fn_onPhoneNumberChange(): void {
    this.fn_validatePhoneNumber();
  }

  fn_validatePhoneNumber(): void {
    let asYouType = new AsYouType(this.obj_selectedCountryCode);
    let phoneNumber = asYouType.input(this.vc_phoneNumber);
    if (phoneNumber != "000000000"){
      this.vc_phoneNumberValid = asYouType.isValid();
    }
    else {
      this.vc_phoneNumberValid = true;
    }

  }
}